// @flow
import * as React from 'react';
import { useContext } from 'react';
import { TableSettingsContext } from '../with-table-settings';
import { IconButton, InputAdornment, MenuItem } from '@mui/material';
import { SelectInput } from '@coverright/ui/inputs';
import { X } from '@phosphor-icons/react';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../app/theme';


export const TableViewSelect = () => {
  const {views, viewName, setViewName, deleteView} = useContext(TableSettingsContext);
  const confirm = useConfirm(theme);

  const handleDeleteClick = () => {
    confirm({
      content: 'Are you sure you want to delete this view?',
      okButtonTitle: 'Yes',
      cancelButtonTitle: 'No',
      title: 'Attention!',
    })
      .then(val => {
        if (val) {
          deleteView();
        }
      })
  }

  return (
    <SelectInput value={viewName} hideTick
                 endAdornment={viewName && <InputAdornment position={'end'} sx={{mr: 2.5}}>
                   <IconButton size={'small'} onClick={handleDeleteClick}>
                     <X color={'#DE3124'} />
                   </IconButton>
                 </InputAdornment>}
                 onChange={event => setViewName(event.target.value as string)}
                 size={'small'}
                 wrapperSx={{'& > div': {mx: .5, width: 'calc(100% - 8px)'} }}>
      <MenuItem value={''}>
        Default
      </MenuItem>
      {views.map(view => (
        <MenuItem key={view} value={view}>
          {view}

        </MenuItem>
      ))}
    </SelectInput>
  );
};
